import { render, staticRenderFns } from "./GenerarJSON.vue?vue&type=template&id=0cba424e&scoped=true"
import script from "./GenerarJSON.vue?vue&type=script&lang=js"
export * from "./GenerarJSON.vue?vue&type=script&lang=js"
import style0 from "./GenerarJSON.vue?vue&type=style&index=0&id=0cba424e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba424e",
  null
  
)

export default component.exports